export enum BackgroundImageType {
  COVER = 'Cover',
  FILL = 'Fill',
  FIT = 'Fit',
  ORIGINAL_SIZE = 'OriginalSize',
  TILE = 'Tile',
}
